<template>
  <v-container>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <div v-if="!edit_loaded">
          <v-skeleton-loader
            v-for="a in 5"
            :key="a"
            type="article"
          ></v-skeleton-loader>
        </div>
        <div v-else>
          <v-alert
            v-if="$route.query.restored"
            color="#7fe16c"
            class="text-center font-weight-bold"
          >
            המוצר שוחזר בהצלחה 😊
          </v-alert>
          <v-card>
            <v-card-title>מוצר חדש</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="form">
                <Form
                  @re_exist="barcode_exist = false"
                  :barcode_exist="barcode_exist"
                  :product="product"
                ></Form>
                <Imgs :product="product"></Imgs>
              </v-form>
            </v-card-text>
          </v-card>
          <div class="d-flex mt-4 mb-10 justify-end">
            <v-btn
              @click="save()"
              :disabled="save_loader"
              :loading="save_loader"
              x-large
              depressed
              height="40"
              color="black white--text ms-3"
              >שמירה</v-btn
            >
          </div>
          <v-dialog persistent max-width="400" v-model="dialog">
            <v-card>
              <v-card-text class="pt-4">
                <v-alert
                  dense
                  type="error"
                  class="text-center"
                  v-if="restoreFails"
                >
                  שחזור המוצר נכשל
                </v-alert>
                <h3 class="text-center text-h6">
                  <span dir="rtl">
                    הברקוד הזה ({{ product.barcode }}) שייך למוצר שנמחק. האם
                    ברצונך לשחזר אותו שוב?
                  </span>
                </h3>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-center">
                <v-btn
                  @click="restoreProduct()"
                  color="primary"
                  :loading="restoreLoading"
                  :disabled="restoreLoading"
                  class="font-weight-bold"
                  large
                >
                  כן
                </v-btn>
                <v-btn @click="dialog = false" large> לֹא </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Form from "@/components/products/form";
import Imgs from "@/components/products/imgs";

export default {
  name: "product_page",
  data() {
    return {
      edit_loaded: true,
      barcode_exist: null,
      save_loader: false,
      dialog: false,
      restoreFails: false,
      restoreLoading: false,
      product: {
        name: "",
        barcode: "",
        quantity: 0,
        quantity_alert: 0,
        maximum: null,
        price: 0,
        sku: null,
        images: [null],
        status: 1,
        sections_ids: [],
        uploaded_images: [],
        brand_id: null,
        sort: null,
        tex: 1,
        cost:0
      },
      items_box: [],
      search: null,
    };
  },
  components: {
    Form,
    Imgs,
  },
  methods: {
    filter(item, queryText, itemText) {
      if (item.header) return false;
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    save() {
      if (this.$refs.form.validate() && !this.save_loader) {
        this.save_loader = true;
        let formData = new FormData();
        let arrays = [
          "sections_ids",
          "resources",
          "paragraphs",
          "tags",
          "images",
          "generations",
        ];
        Object.entries(this.product).forEach((e, i) => {
          if (!arrays.includes(e[0])) {
            formData.append(e[0], e[1]);
          } else if (
            e[0] == "sections_ids" ||
            e[0] == "resources" ||
            e[0] == "tags" ||
            e[0] == "generations"
            // e[0] == "status"
          ) {
            e[1].forEach((x, y) => {
              formData.append(`${e[0]}[${y}]`, x != null ? x : "");
            });
          } else if (e[0] == "images") {
            e[1].forEach((x, y) => {
              if (x != null) {
                formData.append(`${e[0]}[${y}]`, x);
              }
            });
          } else if (e[0] == "paragraphs") {
            e[1].forEach((x, y) => {
              formData.append(`${e[0]}[${y}][title]`, x.title);
              formData.append(`${e[0]}[${y}][description]`, x.description);
            });
          } else if (e[0] == "resources") {
            e[1].forEach((x, y) => {
              formData.append(`${e[0]}[${y}]`, x);
            });
          } else if (e[0] == "generations") {
            e[1].forEach((x, y) => {
              formData.append(`${e[0]}[${y}]`, x);
            });
          }
        });

        this.$store
          .dispatch("public__request", {
            config: {
              url: this.$route.params.id
                ? `products/${this.$route.params.id}`
                : "products",
              method: "post",
            },
            data: formData,
          })
          .then((res) => {
            this.$router.push("/products");
          })
          .catch((err) => {
            this.save_loader = false;
            let errors = err.response.data.data;
            Object.keys(errors).forEach((e) => {
              errors[e].forEach((s) => {
                if (e == "barcode") {
                  this.checkDeletedProduct();
                }
                if (s.includes("already been taken")) {
                  this.$set(this, `${e}_exist`, true);
                }
              });
            });
          });
      }
    },
    edit() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `products/${this.$route.params.id}`,
            method: "get",
          },
        })
        .then((res) => {
          this.product = Object.assign({}, res.data.data);
          this.edit_loaded = true;
        });
    },
    checkDeletedProduct() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `checkDeletedProduct/${this.product.barcode}`,
            method: "get",
          },
        })
        .then((res) => {
          this.dialog = true;
        });
    },
    restoreProduct() {
      if (!this.restoreLoading) {
        this.restoreLoading = true;
        this.$store
          .dispatch("public__request", {
            config: {
              url: `restoreProduct/${this.product.barcode}`,
              method: "put",
            },
          })
          .then((res) => {
            this.$router.replace(
              `/product/${res.data.data.product_id}?restored=true`
            );
            window.location.reload();
          })
          .catch(() => {
            this.restoreLoading = false;
            this.restoreFails = true;
          });
      }
    },
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.edit_loaded = false;
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.edit();
    }
  },
};
</script>
